import { __assign } from 'tslib';
import { number, alpha } from '../numbers/index.js';
import { sanitize, clamp } from '../utils.js';
import { isColorString, splitColor } from './utils.js';
var clampRgbUnit = clamp(0, 255);
var rgbUnit = __assign(__assign({}, number), {
  transform: function (v) {
    return Math.round(clampRgbUnit(v));
  }
});
var rgba = {
  test: isColorString('rgb', 'red'),
  parse: splitColor('red', 'green', 'blue'),
  transform: function (_a) {
    var red = _a.red,
      green = _a.green,
      blue = _a.blue,
      _b = _a.alpha,
      alpha$1 = _b === void 0 ? 1 : _b;
    return 'rgba(' + rgbUnit.transform(red) + ', ' + rgbUnit.transform(green) + ', ' + rgbUnit.transform(blue) + ', ' + sanitize(alpha.transform(alpha$1)) + ')';
  }
};
export { rgbUnit, rgba };